import { render, staticRenderFns } from "./SmartTable.vue?vue&type=template&id=4b2ba48c&scoped=true&"
import script from "./SmartTable.vue?vue&type=script&lang=js&"
export * from "./SmartTable.vue?vue&type=script&lang=js&"
import style0 from "./SmartTable.vue?vue&type=style&index=0&id=4b2ba48c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2ba48c",
  null
  
)

export default component.exports